import { jsx as _jsx } from "react/jsx-runtime";
import { Popconfirm } from "antd";
import { useI18n } from "../../contexts/i18n.js";
const FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT = "confirm:popconfirm-gateway";
const FormValueDifferFromTemplateResetButtonWithConfirm = ({ anchorRef })=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Popconfirm, {
        title: __("Do you really want to irrevocably overwrite all changes to this form with the defaults from the latest version of the template?"),
        cancelText: __("Cancel"),
        okText: __("Reset now"),
        overlayStyle: {
            maxWidth: 450
        },
        onConfirm: ()=>anchorRef.current.dispatchEvent(new CustomEvent(FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT)),
        placement: "topLeft",
        children: /*#__PURE__*/ _jsx("a", {
            style: {
                display: "none"
            },
            ref: anchorRef,
            children: __("Reset to latest template version")
        })
    });
};
export { FORM_DIFFER_RESET_BUTTON_WITH_CONFIRM_CUSTOM_EVENT, FormValueDifferFromTemplateResetButtonWithConfirm };
